import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";


let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  accountId:'FBC07226FEEC4C52B52E2C2772F35693', //Id da conta da IUGU para funcionar  a integração com o cartão de credito
  Loja: "unida",
  UserStorage: "023DA2FB209F49C1803BBB0757D486FB==",
  UserToken: "B7BB25DD74EC40E49A6AF3BA7FA6A746==",
  UrlApi: "https://prd-ecommerce-und-api.primecase.com.br/api",
  // UrlApi: "https://dev-ecommerce-und-api.primecase.com.br/api",
  // UrlApi: "https://hlg-ecommerce-par-api.primecase.com.br/api",
  // UrlApi: "https://localhost:5001/api",
  // UrlLoja:"https://hlg-ecommerce-par-web.primecase.com.br.com.br/",
  UrlLoja: "https://loja.unidadtvm.com.br",
  //UrlLoja: "https://dev-ecommerce-und-web.primecase.com.br",
  UrlServiceHost: "https://prd-und-svc-api.primecase.com.br/",
  SecurityKey: "5AKI104KwDjj",
  OrgId: "9ozphlqx",
  ProviderMerchantId: "braspag_marlim_advanced"
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#e89a11",
      light: "#B799F2",
      //lighter: "#ece6f7",
      dark: darkenColor("#e89a11", 10), // Escurece em 20%
    },
    secondary: {
      main: "#7E7296",
    },
    error: {
      main: "#a91c1c",
    },
  
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
